import {AbstractProfileCollection} from './abstractProfileCollection';
import {Availability} from '../model/availability';

export const Availabilities = AbstractProfileCollection.extend({
    _name: 'Availabilities',
    model: Availability,
    urlRoot: '/availabilities/get.json',
});
